import { useEffect, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import {
  convertCurrencyFormat,
  formatToStandardDate,
} from "../../helper/common";
import { Badge, Button, Card, Checkbox, Icon } from "../design";
import "./IncomeSourceCard.css";

const IncomeSourceCard = ({
  userId,
  amount,
  type,
  selectedSource = [],
  changeSelectedSource,
  onDelete,
  isDeleting = false,
  isPendingDelete = false,
  onCancelPendingDelete,
}) => {
  const { _t } = useTranslator();
  const [isActive, setIsActive] = useState(selectedSource?.includes(type));

  useEffect(() => {
    setIsActive(selectedSource?.includes(type));
  }, [selectedSource]);

  const handleChange = () => {
    changeSelectedSource(userId, type);
  };

  const isMonthlyIncome =
    type === "payslips" ||
    type === "otherIncomes" ||
    type.startsWith("payslip:") ||
    type === "declaredIncome" ||
    type === "bank" ||
    type.startsWith("custom_income:");

  const isCustom = type.startsWith("custom_income:");

  const title = type.startsWith("payslip:")
    ? (() => {
        const [, rawDate, employer] = type.split(":");
        const formattedDate = formatToStandardDate(rawDate?.trim());
        return employer?.trim()
          ? `${_t("payslip")} – ${employer.trim()} (${formattedDate})`
          : `${_t("payslip")} (${formattedDate})`;
      })()
    : type === "payslips"
      ? _t("payslip")
      : type === "otherIncomes"
        ? _t("otherIncomes")
        : isCustom
          ? type.replace("custom_income:", "")
          : _t(type);

  return (
    <Card
      as="div"
      className={`income-source-card-box ${isActive ? "is-selected" : ""} ${
        isPendingDelete ? "is-pending-delete" : ""
      }`}
    >
      <Checkbox
        className="income-source-card-box__check"
        checked={!!isActive}
        onChange={handleChange}
        label={
          <span className="income-source-card-box__title">
            {title}
            <Badge tone={isMonthlyIncome ? "lime" : "neutral"}>
              {isMonthlyIncome ? _t("monthly") : _t("annualInPayslip")}
            </Badge>
          </span>
        }
        description={
          <>
            {convertCurrencyFormat(amount)}€
            {!isMonthlyIncome &&
              ` -> ` +
                convertCurrencyFormat(Math.round(amount / 12)) +
                "€/" +
                _t("mo")}
          </>
        }
      />
      {isCustom &&
        (isPendingDelete ? (
          <Button variant="ghost" size="sm" onClick={onCancelPendingDelete}>
            {_t("undo", "Undo")}
          </Button>
        ) : isDeleting || onDelete ? (
          <Button
            variant="ghost"
            size="sm"
            iconOnly
            loading={isDeleting}
            aria-label={_t("delete")}
            iconStart={<Icon name="close" size={16} />}
            onClick={onDelete}
          />
        ) : null)}
    </Card>
  );
};

export default IncomeSourceCard;
